import { ThreeDots } from "react-loader-spinner";
import styled from "styled-components";
import { Typography } from "./Typography";

const ContainerCenter = styled.div`
  padding: 10%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${props => props.fd ? props.fd : "column"};
`

const Loading = (props) => (
  <ContainerCenter>
    <div style={{ display: props.full ? "block" : "none" }}>
      <img src="logo.png" width={180} alt="Codivas" className="mb-3" />
    </div>
    <ContainerCenter fd="row">
      <Typography fontSize="h2" style={{ paddingRight: "20px" }}>
        {props.label}
      </Typography>
      <ThreeDots
        height="80"
        width="80"
        radius="9"
        color="#4fa94d"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={true}
      />{" "}
    </ContainerCenter>
  </ContainerCenter>
);

export default Loading;
